import { useGtmParamsStorage } from '~/composables/useGtmParamsStorage'

export default defineNuxtPlugin((nuxtApp) => {
  const { runGtmParamStorage } = useGtmParamsStorage()

  // Run after the Vue app is fully mounted on the client.
  nuxtApp.hook('app:mounted', () => {
    runGtmParamStorage()
  })
})
